/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import api from '../../api'

export default {
  SET_BEARER (state, accessToken) {
    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    state.accessToken = accessToken;
  },
  SET_USER (state, user) {
    state.user = user;
  },
  SET_ACCESS_DENIED (state, accessDenied) {
    state.accessDenied = accessDenied;
  },
  SET_PASSWORD_EXPIRED (state, passwordExpired) {
    state.passwordExpired = passwordExpired;
  }
}
